"use client";
import React, { useEffect, useState } from "react";

const InstallPrompt: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if the user is on an iOS device
    const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(isAppleDevice);

    const handleBeforeInstallPrompt = (event: BeforeInstallPromptEvent) => {
      // Prevent the default browser install prompt
      event.preventDefault();
      // Store the event for later use
      setDeferredPrompt(event);
      // Show the custom popup
      setIsVisible(true);
    };

    // Only add the event listener for non-iOS devices
    if (!isAppleDevice) {
      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    }

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Trigger the browser's install prompt
      deferredPrompt.prompt();
      // Wait for the user to respond
      const { outcome } = await deferredPrompt.userChoice;
      // Log the result
      console.log(`User response: ${outcome}`);
      // Hide the custom popup
      setIsVisible(false);
      // Clear the deferred prompt
      setDeferredPrompt(null);
    }
  };

  const handleCloseClick = () => {
    // Hide the custom popup
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4 font-sans bg-black bg-opacity-50">
      <div className="w-full max-w-sm p-6 text-center bg-white rounded-lg shadow-lg">
        <h2 className="mb-4 text-xl font-bold">Install App</h2>
        {isIOS ? (
          <>
            <p className="mb-6 text-gray-700">
              Untuk install aplikasi ini pada iPhone, tap tombol{" "}
              <strong>Share</strong> pada Safari dan pilih{" "}
              <strong>
                &quot;Add to Home Screen&quot; atau &quot;Tambahkan ke layar
                beranda&quot;
              </strong>
              .
            </p>
            <button
              type="button"
              onClick={handleCloseClick}
              className="px-4 py-2 text-white transition rounded-lg bg-primary hover:bg-primary/80"
            >
              Tutup
            </button>
          </>
        ) : (
          <>
            <p className="mb-6 text-gray-700">
              Install aplikasi absen ke halaman utama!
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleInstallClick}
                className="px-4 py-2 text-white transition rounded-lg bg-primary hover:bg-primary/80"
              >
                Install
              </button>
              <button
                onClick={handleCloseClick}
                className="px-4 py-2 text-gray-700 transition bg-gray-300 rounded-lg hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;
